import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconVPetProps } from './IconVPet.types'
import * as Styled from './styles/IconVPet.style'

import { nonThemeableRules } from '../../ruleSet'

const IconVPet: FC<IconVPetProps> = ({
  size = nonThemeableRules.defaultSize as number as IconVPetProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconVPetProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 192 192' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path
            d='M57.5 132.2c-3-2.6-6.3-2.4-13.4-5.2-5.1-2.1-9.3-5.9-12-10.7C18.6 93 37.8 72.5 58.2 77.7c8.2 2.1 14.8 1.9 18.3-.2 3.3-2 7-3.2 10.8-3.7 12.6-1.4 22.2 8.3 22.2 8.3s9.7 9.6 8.3 22.2c-.5 3.8-1.7 7.5-3.7 10.8-2.1 3.6-2.3 10.1-.2 18.3 5.3 20.4-15.3 39.6-38.6 26.1-4.8-2.7-8.5-6.9-10.7-12-2.8-7.1-2.5-10.3-5.2-13.3l-1.9-2z'
            vectorEffect='non-scaling-stroke'
          />
          <ellipse cx='142.9' cy='77.6' rx='14.1' ry='11.5' transform='rotate(-45.001 142.887 77.626)' vectorEffect='non-scaling-stroke' />
          <ellipse cx='73.9' cy='47.9' rx='14.1' ry='11.5' transform='rotate(-45.001 73.886 47.855)' vectorEffect='non-scaling-stroke' />
          <ellipse
            cx='144.1'
            cy='118.9'
            rx='14.1'
            ry='11.5'
            transform='rotate(-45.001 144.086 118.855)'
            vectorEffect='non-scaling-stroke'
          />
          <ellipse cx='113.1' cy='48.8' rx='14.1' ry='11.5' transform='rotate(-45.001 113.12 48.846)' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconVPet
